"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeMachine = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../app");
const helpers_1 = require("../utils/helpers");
const date_picker_1 = require("./date_picker");
const form_for_1 = require("./form_for");
const moment = require("moment");
const dateTimePicker = (0, date_picker_1.DateTimePicker)({ dateFormat: "YYYY-MM-DD" });
let status = 'ok';
let changed = false;
exports.TimeMachine = {
    time: moment(),
    active: false,
    oncreate() {
        app_1.App.get(`/time_machine/get`).then((x) => {
            let data = x;
            this.active = data.active,
                this.time = moment(data.now);
        });
    },
    update() {
        let time = this.time.clone();
        status = 'loading';
        return app_1.App.get(`/time_machine/set?active=${this.active ? 't' : 'f'}&time=${encodeURI(time.tz('UTC').format())}`).then(() => {
            status = 'ok';
            changed = false;
        });
    },
    renderOptions() {
        if (this.active) {
            let btnClass = status === 'loading' ? 'button is-loading' : 'button';
            return [
                (0, mithril_1.default)(dateTimePicker, {
                    onchange: (value) => {
                        if (value) {
                            this.time = moment(value, "YYYY-MM-DD HH:mm");
                        }
                        else {
                            this.time = moment();
                        }
                        changed = true;
                    },
                    value: moment(this.time).format("YYYY-MM-DD HH:mm")
                }),
                (0, form_for_1.gaplessColumns)((0, mithril_1.default)("button", {
                    class: `${btnClass} is-primary`,
                    onclick: () => {
                        this.time = moment();
                        this.update();
                    }
                }, (0, helpers_1.iconSpan)("fa-time"), "Maintenant"), (0, mithril_1.default)("button", {
                    class: `${btnClass} is-warning`,
                    disabled: !changed,
                    onclick: () => {
                        status = 'waiting';
                        this.update();
                    }
                }, (0, helpers_1.iconSpan)("fa-time"), "Confirmer"))
            ];
        }
        return undefined;
    },
    view(_node) {
        return (0, mithril_1.default)("div", { class: "content timemachine" }, (0, form_for_1.columns)((0, form_for_1.checkbox)((0, mithril_1.default)("strong", "TimeMachine™ (debug)"), "active", this, {
            oninput: (evt) => { this.active = evt.target.checked; this.update(); }
        }), this.renderOptions()));
    }
};
